import { CollectionDocumentType } from "../../../graphql/generated";

export const generateDocButton = [
  CollectionDocumentType.SuratPengakuanHutang,
  CollectionDocumentType.Sp_1,
  CollectionDocumentType.Sp_2,
  CollectionDocumentType.Sp_3,
];
